module.exports = __webpack_public_path__ + "static/media/zepf58.3e815c67.png";